import type { SourceChanges } from '../api'

export function changeSummary(ops: SourceChanges['ops']): { added: number; removed: number } {
  const words = (s: string) => s.split(/\s+/).filter(Boolean).length
  return ops.reduce((acc, o) => o.op === 'insert' ? { ...acc, added: acc.added + words(o.text) }
    : o.op === 'delete' ? { ...acc, removed: acc.removed + words(o.text) } : acc, { added: 0, removed: 0 })
}

const w = (n: number) => `${n} ${n === 1 ? 'word' : 'words'}`

/** "12 words added, 3 removed" */
export function changeSummaryText({ added, removed }: { added: number; removed: number }): string {
  if (!added && !removed) return 'No words changed'
  if (!removed) return `${w(added)} added`
  if (!added) return `${w(removed)} removed`
  return `${w(added)} added, ${removed === 1 ? '1 word' : removed} removed`
}
